module.exports.minion = {
  vi: {
    title: 'Tay sai của Mordred trong Avalon: luật và chiến thuật',
    description:
      'Tay sai của Mordred biết gì trong Avalon? Tìm hiểu họ thấy đồng minh Ác nào, khi nào được chọn Thành công hoặc Thất bại và điểm khác Mordred, Oberon.',
    keywords: ['Tay sai của Mordred', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Lacaio de Mordred em Avalon: regras e estratégia',
    description:
      'O que os Lacaios de Mordred sabem em Avalon? Aliados visíveis, escolha entre Sucesso e Falha e diferenças para os papéis de Mordred e Oberon.',
    keywords: ['Lacaio de Mordred', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Minion of Mordred in Avalon: Rules & Strategy',
    description:
      'What do Minions of Mordred know in Avalon? Learn which evil allies they see, when they can play Success or Fail and how they differ from Mordred and Oberon.',
    keywords: ['Minion of Mordred', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Миньон в Авалоне: приспешник Мордреда и его правила',
    description:
      'Кого знает Миньон в Авалоне? Злые союзники, выбор успеха или провала и отличие приспешника Мордреда от ролей Мордреда и Оберона.',
    keywords: ['Приспешник Мордерда', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆士兵：莫德雷德爪牙的規則與策略',
    description: '阿瓦隆莫德雷德的爪牙知道誰？了解士兵能認出的壞人、成功或失敗的選擇，以及與莫德雷德和奧伯倫的區別。',
    keywords: ['莫德雷德的爪牙', '角色', '規則', '攻略'],
  },
  'zh-CN': {
    title: '阿瓦隆士兵：莫德雷德爪牙的规则与策略',
    description: '阿瓦隆莫德雷德的爪牙知道谁？了解士兵能认出的坏人、成功或失败的选择，以及与莫德雷德和奥伯伦的区别。',
    keywords: ['莫德雷德的爪牙', '角色', '规则', '建议'],
  },
  es: {
    title: 'Secuaz de Mordred en Avalon: reglas y estrategia',
    description:
      '¿Qué saben los Secuaces de Mordred en Avalon? Aliados visibles, elección entre Éxito y Fracaso y diferencias con los roles de Mordred y Oberon.',
    keywords: ['Esbirros de Mordred', 'Rol', 'Reglas', 'Consejos'],
  },
};
